import { useEffect, useState } from 'react'

import { useSearchParam } from 'react-use'

import { ViewerPosition } from '../types'

export const useViewerPosition = () => {
  const [viewerPosition, setViewerPosition] = useState<ViewerPosition>({
    yaw: 0,
    pitch: 0,
    hfov: 120,
  })
  const pitchParam = useSearchParam('pitch')
  const yawParam = useSearchParam('yaw')
  const hfovParam = useSearchParam('hfov')

  const getInitialPosition = (_isMaster: boolean) => {
    const initialPosition = { ...viewerPosition }

    // Try reading initial position from query params
    if (pitchParam && yawParam) {
      initialPosition.pitch = parseFloat(pitchParam)
      initialPosition.yaw = parseFloat(yawParam)
      if (hfovParam) {
        initialPosition.hfov = parseFloat(hfovParam)
      }
    }

    return initialPosition
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper newValues type
  const updateViewerPosition = (newValues: any) => {
    const newVal = { ...viewerPosition, ...newValues }
    setViewerPosition(newVal)
  }

  useEffect(() => {
    setViewerPosition(getInitialPosition(true))
    // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO: getInitialPosition intentionally omitted - should only run once on mount
  }, [])

  return { viewerPosition, updateViewerPosition, getInitialPosition }
}
